import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { useProductSettingsContext } from '../context/ProductSettingsContext';
import { PutProductDistributorFulfillmentType } from '../hooks/useFetchProductSettingsDistributorOverrides';
import { SkuFulfillmentMethod } from '../../../Enums/SkuFulfillmentMethod';
import { toYyyyMmDdInput, isSunday, maxInMarketDate } from '../utils/inMarketDate';

export const DistributorInMarketDatePicker = ({ row, handleUpdateRow }) => {
    const { getDistributorFloorDate, showInMarketDateError } = useProductSettingsContext();
    const isReplenishable = row.skuFulfillmentType?.id === SkuFulfillmentMethod.REPLENISHABLE;
    const isOrderOnly = row.skuFulfillmentType?.id === SkuFulfillmentMethod.ORDER_ONLY;
    const disabled = row?.legal === false || (!isReplenishable && !isOrderOnly);
    const value = toYyyyMmDdInput(row.inMarketDateOverride);
    const min = getDistributorFloorDate(row);
    const max = maxInMarketDate();

    const handleChange = async (newValue) => {
        let apiDate;
        if (newValue === null) {
            apiDate = null;
        } else {
            if (!newValue.isValid()) return;
            const selected = newValue.format('YYYY-MM-DD');
            // Guard against typed input that bypasses the disabled calendar days.
            if (!isSunday(selected)) {
                showInMarketDateError('In-market date must be a Sunday.');
                return;
            }
            if (min && selected < min) return;
            if (selected > max) return;
            apiDate = selected;
        }

        const updatedRow = {
            ...row,
            inMarketDateOverride: apiDate ? `${apiDate}T00:00:00` : null,
            inMarketDateIsDefault: !apiDate
        };

        await handleUpdateRow(updatedRow);
        await PutProductDistributorFulfillmentType(
            row.product,
            { ...updatedRow, skuFulfillmentType: row.skuFulfillmentType },
            null,
            { setInMarketDate: true, inMarketDate: apiDate }
        );
    };

    return (
        <DatePicker
            value={value ? dayjs(value) : null}
            disabled={disabled}
            onChange={handleChange}
            minDate={min ? dayjs(min) : undefined}
            maxDate={dayjs(max)}
            shouldDisableDate={(date) => date.day() !== 0}
            slotProps={{
                textField: { size: 'small', fullWidth: true },
                field: { clearable: true }
            }}
        />
    );
};

DistributorInMarketDatePicker.propTypes = {
    row: PropTypes.object,
    handleUpdateRow: PropTypes.func
};
